import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../features/auth/useAuth";

export const RequireAuth = () => {
    const { isLoggedIn } = useAuth();
    const location = useLocation();

    // ログインしていない場合
    if (!isLoggedIn) {
        // 現在のパス（/logs/terminal-status）とクエリ（?signature=...）を結合してエンコード
        const redirectPath = encodeURIComponent(location.pathname + location.search);
        
        // URLパラメータとして明示的に持たせる
        return <Navigate to={`/login?redirect=${redirectPath}`} replace />;
    }

    return <Outlet />;
};